import dark from './dark';
import light from './light';
import primary from './primary';
import secondary from './secondary';

export default {
  dark,
  light,
  secondary,
  primary,
};
